import AppConfig from "util/AppConfig";
const useFeature = (name) => AppConfig.isFeatureEnabled(name);
export default useFeature;
